<template>
	<v-container fluid>
		<v-row>
			<v-col cols="11">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="1">
				<export-excel :items="items" :headers="headers" :fileName="'لیست وام های طرف حساب'">
				</export-excel>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="items" :items-per-page="500" :search="search"
					class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>{{ row.item.userLoanCode }}</td>
							<td>{{ row.item.userLoanTitle }}</td>
							<td>
								{{ row.item.memberModel.fullName }}
								<div class="grey--text">کد ملی: {{ row.item.memberModel.nationalCode }}</div>
							</td>
							<td class="text-center">{{ row.item.userLoanStartDate_Persian.date }}</td>
							<td>
								{{ row.item.userLoanAmount.toString().toPriceFormat() }}
							</td>
							<td>
								{{ row.item.share.toString().toPriceFormat() }}
							</td>
							<td class="text-center">
								{{ row.item.dueDate_Persian ? row.item.dueDate_Persian.date : '' }}
							</td>
							<td class="text-center">
								<div class="info--text" style="cursor: pointer;" @click="transactionList(row.item)">{{
									row.item.sumSponsorPayments.toString().toPriceFormat() }}</div>
								<div @click="transaction(row.item)"><small class="secondary--text" style="cursor: pointer;">ثبت
										واریزی</small></div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifyTransaction v-if="dialogTransaction" :data="selectedTransaction" @callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogContactTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogContactTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<ContactTransactions v-if="dialogContactTransactionsList" :contact="contact"
						:userLoanContact="selectedUserLoanContact" @update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { emptyId } from '@/util/emptyId'

export default {
	name: 'ContactUserLoans',
	props: {
		contact: { type: Object },
	},
	components: {
		ConfirmDlg: () => import('@/components/Confirm'),
		ContactTransactions: () => import('./ContactTransactions.vue'),
		ModifyTransaction: () => import('@/views/admin/ModifyTransaction'),
	},
	data() {
		return {
			selectedTransaction: null,
			selectedUserLoanContact: null,
			dialogContactTransactionsList: false,
			dialogTransaction: false,
			errorMessages: '',
			search: '',
			loading: false,
			headers: [
				{
					text: 'شماره وام',
					align: 'start',
					sortable: true,
					value: 'userLoanCode',
					width: 50
				}, {
					text: 'عنوان وام',
					align: 'start',
					sortable: true,
					value: 'userLoanTitle',
				},
				{
					text: 'نام مشتری',
					align: 'start',
					sortable: true,
					value: 'memberModel.fullName',
					width: 150
				},
				{
					text: 'کد ملی',
					align: 'start d-none',
					sortable: true,
					value: 'memberModel.nationalCode',
				},
				{
					text: 'تاریخ شروع وام',
					align: 'center',
					sortable: true,
					value: 'userLoanStartDate_Persian',
				},
				{
					text: 'مبلغ وام',
					align: 'center',
					sortable: true,
					value: 'userLoanAmount',
				},
				{
					text: 'سهم',
					align: 'center',
					sortable: true,
					value: 'share',
				},
				{
					text: 'سررسید تسویه',
					align: 'center',
					sortable: true,
					value: 'dueDate_Persian',
				},
				{
					text: 'مجموع واریز اسپانسر',
					align: 'center',
					sortable: false,
					value: 'sumSponsorPayments'
				}
			],
			items: [],
		}
	},
	mounted() {
		this.loadData()
	},
	methods: {
		loadData() {
			this.loading = true
			api.get('admin/Contact/GetLoansByContactId/' + this.contact.id, null)
				.then(response => {
					this.items = response
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		transaction(item) {
			this.selectedTransaction = { id: emptyId, paymentMethod: 2, isWithdraw: true, contact: { id: this.contact.id, businessName: this.contact.businessName, phone: this.contact.phone, fullName: this.contact.fullName, bankInfo: this.contact.bankInfo }, userLoanContact: { id: item.id, title: `شماره وام: ${item.userLoanCode}, عنوان: ${item.userLoanTitle}`, userLoanCode: item.userLoanCode }, amount: Math.max(item.share - item.sumSponsorPayments, 0), maxAmount: item.share - item.sumSponsorPayments }
			this.dialogTransaction = true
		},
		callbck_transaction(result) {
			this.dialogTransaction = false
			if (result) {
				this.loadData()
				this.$emit('update')
			}
		},
		transactionList(userLoanContact) {
			this.selectedUserLoanContact = userLoanContact
			this.dialogContactTransactionsList = true
		}
	},
}
</script>
<style></style>
